import { BaseTabelaPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layouts';
export default function TabelaRetornoPDF(props) {
    var _a, _b;
    const { titulo, periodo, layout = 'default', obj_datas, useBold } = props;
    let tituloDefault = '';
    if (obj_datas) {
        tituloDefault = `Retorno da Carteira x Benchmarks. Período de análise: de ${(_a = obj_datas === null || obj_datas === void 0 ? void 0 : obj_datas.data_ini) !== null && _a !== void 0 ? _a : '-'} a ${(_b = obj_datas === null || obj_datas === void 0 ? void 0 : obj_datas.data_fim) !== null && _b !== void 0 ? _b : '-'}`;
    }
    const columns = getLayouts(periodo)[layout];
    const didParseCell = (data) => {
        if (useBold && data.section === 'body' && (data.row.index === 0 || data.row.index === 1)) {
            data.cell.styles.fontStyle = 'bold';
        }
    };
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { titulo: titulo !== null && titulo !== void 0 ? titulo : tituloDefault, columns, tableConfig: {
            didParseCell,
        } }));
}
